// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import { store } from './store/store'
import axios from 'axios'
import VueAxios from 'vue-axios'

Vue.use(VueAxios, axios)

Vue.config.productionTip = false

export const eventBus = new Vue();

Vue.filter('capitalize', function (value) {
    if (value) {
        value = value.toString()
        return value.charAt(0).toUpperCase() + value.slice(1)
    }
    return ''
})

Vue.filter('trim', function (value, limit) {
    if (value.length <= limit) return value
    value = value.toString()
    var newValue = value.slice(0, limit)
    return newValue + '...'
})

router.beforeEach((to, from, next) => {
    if (
        store.state.sessionUser 
        && to.meta.hasOwnProperty('restrictedTo')  
        && to.meta.restrictedTo.indexOf(store.state.sessionUser.roles[0]) === -1
    ) {
        console.log('router /dashboard')
        next({ path: '/dashboard' })
    } else {
        console.log('router else')
        next()
    }
})

/* eslint-disable no-new */
new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')



// WEBPACK FOOTER //
// ./src/main.js